import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Content } from './Layout'
import Card from './Card'
import '../styles/navigation.css'

const cardRows = [
  [{
    icon: 'ac-home',
    header: 'Home.',
    text: 'Founded in 2011, we started a journey that would transform the way organisations manage assets and data. ',
    url: '/'
  },
  {
    icon: 'ac-neuron',
    header: 'Life @bronzelabs.',
    text: 'Our mission is to continually adopt new and innovative technologies to build something better in a world that’s becoming ever reliant on data and connectivity.',
    url: '/about'
  }],
  [{
    icon: 'ac-graduation-hat',
    header: 'Careers.',
    text: 'We’re always looking for talented, versatile and passionate people itching to bring their ideas into the universe.',
    url: '/careers'
  },
  {
    icon: 'ac-bulb-on',
    header: 'Solutions.',
    text: 'Helping companies quickly implement solutions to the hardest problems they face.',
    url: '/solutions'
  }],
  [{
    icon: 'ac-f42',
    header: 'Framework.<sup>42</sup>',
    text: 'One system, multiple opportunities to improve life with a smarter, more intelligent IoT enablement solution.',
    url: '/framework42'
  },
  {
    icon: 'ac-mwkr-alt',
    header: 'mobile.wkr',
    text: 'The complete mobile working solution that brings quantifiable benefits to your business.',
    url: '/mobilewkr'
  }]
]

class Navigation extends Component {
  render () {
    return (
      <nav>
        <div className='logo'>
          <div className='icon ac ac-bronzelabs' />
          <div className='text'>
            <div className='bold'>bronze</div>
            <div className='light'>labs.</div>
          </div>
        </div>
        <section>
          {
            cardRows.map((row, index) => (
              <Row key={index}>
                {
                  row.map((card, index) => (
                    <Content key={index}><Card options={card} onClick={() => this.props.toggleNavigation()} /></Content>
                  ))
                }
              </Row>
            ))
          }
        </section>
        <section className='noVerticalPadding'>
          <Row>
            <Content classes={['contentFull']}>
              <h2>Contact Us</h2>
              <p>Fancy a catchup? Need some help? Email or call us directly and a member of our team will be able to get the help that you are after. Although you can contact us at any time, the best times are between 10am-4pm, weekdays.</p>
            </Content>
          </Row>
          <div id='google-map' />
        </section>
      </nav>
    )
  }
}

Navigation.propTypes = {
  toggleNavigation: PropTypes.func
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation.js